import { Flex, Text, Icon } from '@chakra-ui/react';
import React from 'react';

import { SelectedPipeline } from './SelectedPipeline';
import { FiCalendar } from 'react-icons/fi';

export const DateAndVersionInput = ({
  selectedPipeline,
  onClick,
  children,
}: {
  selectedPipeline: SelectedPipeline | null;
  onClick: () => void;
  children?: React.ReactNode;
}) => {
  const formatDate = (dateString: string) => {
    const [year, month, day] = dateString.split('-').map(Number);
    return new Date(year, month - 1, day);
  };

  return (
    <Flex
      borderWidth="1px"
      borderRadius="5px"
      padding="6px 16px"
      minHeight="40px"
      alignItems="center"
      cursor="pointer"
      onClick={onClick}
    >
      <Icon as={FiCalendar} marginRight="10px" h="inherit" />
      {selectedPipeline ? (
        <Text>
          {`${formatDate(selectedPipeline.reportingDate).toLocaleDateString(
            undefined,
            {
              year: 'numeric',
              month: 'short',
              day: 'numeric',
            },
          )} - version ${selectedPipeline.fileVersion}`}
        </Text>
      ) : (
        <Text>Select Date and Version</Text>
      )}
      {children}
    </Flex>
  );
};
